<template>
    <div id="userinfo">
        <HrrBreadcrumb PMname="用户权限管理" CMname="个人信息" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-card class="box-card" style="margin-top:10px;" shadow="never">
                    <el-form class="user" :model="form" :rules="rules" ref="form" label-width="120px" style="width:400px;">
                        <el-form-item label="用户名：" prop="userAccount">
                            <el-input v-model="form.userAccount" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="昵称：">
                            <el-input v-model="form.userNick"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：" prop="userName" >
                            <el-input v-model="form.userName" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="手机：" prop="userMobile">
                            <el-input v-model="form.userMobile"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" prop="userEmail">
                            <el-input v-model="form.userEmail"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="用户类型：" prop="userType" >
                            <el-radio-group v-model="form.userType" >
                                <el-radio :label="'1'" disabled>管理员</el-radio>
                                <el-radio :label="'0'" disabled>普通用户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="用户状态：" prop="status" >
                            <el-radio-group v-model="form.status" >
                                <el-radio :label="1" disabled>启用</el-radio>
                                <el-radio :label="0" disabled>禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>-->
                    </el-form>
                    <div>
                        <el-button type="primary" @click="onSubmit()">保 存</el-button>
                    </div>
                </el-card>
            </template>
        </HrrMainCardLayout>
    </div>
</template>
<script>
export default {
    name: "Personal",
    data() {
        var validateMobile = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('手机号不能为空'));
            } else {
                var reg = /^[1][0-9]{10}$/;
                if (reg.test(value) == false) {
                    callback(new Error('手机号格式不正确'));
                } else {
                    callback();
                }
            }
        };
        var validateEmail = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('Email不能为空'));
            } else {
                var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,8}$/;
                if (reg.test(value) == false) {
                    callback(new Error('Email格式不正确'));
                } else {
                    callback();
                }
            }
        };
        var validateNameCN = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('姓名不能为空'));
            } else {
                var reg = /^[\u4E00-\u9FA5]{2,15}$/;
                if (reg.test(value) == false) {
                    callback(new Error('请填写中文姓名'));
                } else {
                    callback();
                }
            }
        };
        return {
            form: {
                userAccount: "",
                userNick: "",
                userName: "",
                userMobile: "",
                userEmail: ""
            },
            rules: {
                userName: [{ required: true, validator: validateNameCN, trigger: 'blur' }],
                userMobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
                userEmail: [{ required: true, validator: validateEmail, trigger: 'change' }]
            }
        }
    },
    methods: {
        onSubmit() {
            let Vuethis = this;
            this.loading = true;
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$hrraxios.put(this.$api.system.putcustom, this.form)
                        .then(function(response) {
                            Vuethis.loading = false;
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$message.success("修改成功");
                            } else {
                                Vuethis.$message.error(data.Prompt);
                            }
                        })
                        .catch(function(error) {
                            Vuethis.loading = false;
                        });
                }
            })
        },
        initData() {
            let Vuethis = this;
            this.$hrraxios.get(this.$api.system.getcustom, {
                    params: {}
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.form = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                })
        }

    },
    created() {
        this.initData();
    }
}
</script>